import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'; // Import RouterProvider
import { router } from './router'; // Import your configured router
import { ThemeProvider } from "./contexts/ThemeContext.tsx"
import { AuthProvider } from './contexts/AuthContext.tsx'
import './lib/i18n'
import { TeamProvider } from './contexts/TeamContext.tsx';
import { IntegrationProvider } from './contexts/IntegrationContext.tsx';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider>
      <AuthProvider>
        <TeamProvider>
          <IntegrationProvider>
            <RouterProvider router={router} />
          </IntegrationProvider>
        </TeamProvider>
      </AuthProvider>
    </ThemeProvider>
  </StrictMode>,
)